export default __webpack_public_path__ + "static/media/restrick-withaccess-control-policy.8013fcc7.jpg";